import Widget from 'models/dashboard/widget'

Widget.TagRatingWidget = Widget.extend({
  tagIds: function () {
    return this.get('tag_ids');
  }
});

export default Widget.TagRatingWidget;

